export const TRAVEL_BUDGET_LABELS = {
  backpacker: '背包客',
  budget: '小資旅行',
  standard: '舒適品質',
  premium: '五星享受',
  low: '背包客',
  mid: '小資旅行',
  high: '五星享受'
};

export const TRAVEL_BUDGET_OPTIONS = [
  { value: 'backpacker', label: '背包客' },
  { value: 'budget', label: '小資旅行' },
  { value: 'standard', label: '舒適品質' },
  { value: 'premium', label: '五星享受' }
];

export const normalizeTravelBudget = (value) => ({
  low: 'backpacker',
  mid: 'budget',
  high: 'premium'
}[value] || value);

export const TRAVEL_GENDER_LABELS = {
  any: '性別不限',
  female: '限女性',
  male: '限男性'
};

export const TRAVEL_GENDER_OPTIONS = [
  { value: 'any', label: '性別不限' },
  { value: 'female', label: '限女性' },
  { value: 'male', label: '限男性' }
];
